module.exports = __webpack_public_path__ + "img/logo.a409058d.png";